const frontierModules = [
  ["cms-frontier/buyability", "buyability-sub-app/CMSBuyAbility"],
  ["mops/moving-calculator", "mst-ui-components-ccms/MovingCalculator"],
  ["mops/packing-supplies", "mst-ui-components-ccms/PackingSupplies"],
  ["mops/moving-truck", "mst-ui-components-ccms/MovingTruck"],
  ["mops/moving-container", "mst-ui-components-ccms/MovingContainer"],
  ["mops/ads-component", "mst-ui-components-ccms/AdsComponent"]
  // Future team registrations:
  // ['mortgage-team/rate-calculator', 'mortgage-sub-app/RateCalculator'],
  // ['rental-team/listing-card', 'rental-sub-app/ListingCard'],
];
export {
  frontierModules
};
